import { ENavigation } from 'shared/types/navigation';
import { TApplicationState } from 'shared/types/redux';

export const selectScrollTo = (state: TApplicationState): ENavigation | undefined => {
  return state.scrollTo.value;
};
